/*
http://localhost:8000/sapi/u_trade2/{ school_student_id }/

注：当学员没有加入一个班级时，无法向一个班级付费。如果想实现这步操作，需要先调加入班级接口，然后再调收费接口。

    :param request:
        {
            "operator_id": 4,  # 经办人的user_id，可选范围为校长、老师、行政人员，原接口的'oprID'
            "class_id": 16,  # 缴费至哪个班级，或从哪个班级退费，为空则表示充值给学校（存到该学员在该学校的credit里）或从学校credit里退钱给家长，原接口的'clsID'
            "trade_type": 1,  # 1:缴费，2:退费，原接口的'optType'，对应models中的 trType 字段
            "amount_payable": 100,  # 应付金额，单位是元，可为空
            "discount_amount": 0,  # 优惠所扣减的金额，单位是元，可为空
            "amount_of_money": 200,  # 缴费或退费的金额，原接口的'cost'
            "lesson_quantity": 12,  # 购买或退的课次|课小时，可为空，原接口的'quantity'
            "end_date": 2017-12-01,  # 当class为按日期时此字段有用，原接口的'endDate'
            "remark": "这个学生需要注意提醒续费",  # 备注信息，仅给校长看的
            "payment_method": 0,  # 付款或退款的方法：0:现金；1:信用卡; 2:支票; 3:转账 4:学校授与的Credit 5:存在ClassTop的deposit（校长暂时无法选择5）
                                  # 6:wxBarCodePay:微信条码 7:aliBarCodePay:支付宝扫码枪, 8: wxNativePay:微信网页支付；9: aliWebPay:支付宝网页支付；
                                  # 10: 微信转账（未通过classtop转账）, 11: 支付宝转账（未通过classtop转账）
            "email_recipient": "adam@classtop.com",  # 接收电子transaction summary的email
            "send_email_or_not": 1,  # 是否发电子收据的标识，0:不发，1:发
            "paper_receipt_num": "AB1232",  # 如果线下给了纸质单据，这里填纸质单据的号码，没有则为空
            "trade_date": "2017-10-11",  # 付款日期，默认载入当前日期，可手动更改
        }

    :param pk: school_student_id
    :return: 成功时：
        {

            'result': 'success',
            'school_student_id': 1,
            'school_student_name': 'Adam Song',
            'trade_id': 9
            'trade_type': 1,  #1=缴费 2=退费
            'amount_of_money': 100,  # 单位：元
            'payment_state': 1,  # 0:付款未成功 1:付款已成功 2:线下付款记录（未在系统内付款，仅记录）
            'class_id': 15,
        }
        失败时：
        {'result': 'failure', 'reason': 'wrong payment_method'}
*/

import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const TRADE_TYPE = ['', 'charge', 'refund']
const PAYMENT_METHOD = [
  'cash', // 0
  'credit_card', // 1
  'cheque', // 2
  'bank_transfer', // 3
  'school_credit', // 4
  '_', // 5
  'wechat_barcode_pay', // 6
  'ali_barcode_pay', // 7
  'wechat_native_pay', // 8
  'ali_web_pay', // 9
  'wechat_record_only', // 10
  'ali_record_only', // 11
];

export const schema = Joi.object().keys({
  // NOTE: operator_id is not a school ID. It is the id of the owner of the school
  operator_id: Joi.number().integer().required(), // 经办人的user_id，可选范围为校长、老师、行政人员，原接口的'oprID'
	class_id: Joi.number().integer().allow(null),
  trade_type: Joi.string().valid(TRADE_TYPE).required(),
	amount_payable: Joi.number(),
	discount_amount: Joi.number(),
	amount_of_money: Joi.number().required(),
  lesson_quantity: Joi.number(),
  end_date: Joi.string().allow(null),
  remark: Joi.string().allow(''),
  payment_method: Joi.string().valid(PAYMENT_METHOD).required(),
  email_recipient: Joi.string().email().allow(''),
  send_email_or_not: Joi.boolean(), // this is actually required. But if you pass 'null' we will treat it as 'false'
  paper_receipt_num: Joi.string().allow(''),
  trade_date: Joi.string().required()
});

export function validateForm(data) {
  return Joi.validate(data, schema, {
    abortEarly: false,
  });
}

export default function updateStudentTrade(studentId, tradeInfo) {

  if(!studentId){
    throw new Error('Missing student ID');
  }

  let validateResult = validateForm(tradeInfo);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  let toServer = {
    ...tradeInfo,
    trade_type: TRADE_TYPE.indexOf(tradeInfo.trade_type),
    payment_method: PAYMENT_METHOD.indexOf(tradeInfo.payment_method),
    send_email_or_not: tradeInfo.send_email_or_not === true ? 1 : 0,
    amount_of_money: Number(tradeInfo.amount_of_money),
  }


  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/u_trade2/${studentId}/`,
		'method': 'POST',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject();
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/student/updateStudentTrade.js